import { CTAButton, WordSlider } from '@components';
import { ContainerLayout } from '@layouts';
import classNames from 'classnames';
import Image from 'next/image';
import Link from 'next/link';
import styles from './styles.module.scss';

export const HeroContent = () => (
  <ContainerLayout
    outerContainerClassName={styles.outerContainer}
    innerContainerClassName={styles.innerContainer}
  >
    <div className={styles.contentContainer}>
      <div className={classNames(styles.contentContainerItem, styles.modContentContainerItemLeft)}>
        <WordSlider words={['Empower.', 'Engage.', 'Elevate.']} />
        <h1>Unleash the Potential of Your Employees with Gamified Rewards and Recognition.</h1>
        <div>
          <CTAButton
            variant="contained"
            className={classNames(styles.button, styles.buttonPrimary)}
          >
            <Link prefetch={false} href="/get-started">
              Login / Sign up
            </Link>
          </CTAButton>
          <CTAButton variant="contained" className={styles.button}>
            <Link prefetch={false} href="/schedule-a-demo">
              Schedule a demo
            </Link>
          </CTAButton>
        </div>
      </div>

      <div className={styles.contentContainerItem}>
        <Image
          src="https://cdn.perksbar.com/perksbar-web/products.png"
          alt="Product Image"
          className={styles.productImage}
          width={1055.05}
          height={688}
          quality={85}
          priority
        />
      </div>
    </div>
  </ContainerLayout>
);

HeroContent.displayName = 'HeroContent';

export default HeroContent;
